import { ClaimAddressDto } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { maxLength, minLength } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

export class ClaimAddressDraftValidator extends Validator<ClaimAddressDto> {
  constructor() {
    super();

    this.forField("street1", [maxLength(35)]);

    this.forField("street2", [maxLength(35)]);

    this.forField("suburb", [maxLength(60)]);

    this.forField("postCode", [minLength(4), maxLength(10)]);

    this.forField("city", [maxLength(60)]);
  }
}
